$script('https://use.typekit.net/ind3ink.js', function() {
	try{Typekit.load();}catch(e){}
});

$script.path('/assets/');

$script([
	'static/js/jquery-2.1.4.min.js',
	'static/js/modernizr.js',
], function() {
	$script('js/libs.js?1474965260', function() {
		$script('js/utils.js?1474965260', function() {
			$script('js/plugins.js?1474965260', function() {
				$script('js/site.js?104');
			});
		});
	});
});

var retina = function() {
	var media = '(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)';

	if (!window.matchMedia || !window.matchMedia(media).matches) {
		return;
	}

	[].slice.call(document.querySelectorAll('.js-img')).forEach(function(img) {
		var preload = new window.Image();
		var src = img.dataset.src;

		preload.onload = function() {
			img.setAttribute('src', src);
		};
		preload.src = src;
	});
};

retina();
